import { useEffect, useRef } from "react";

const CLIENT_ID = "ca-pub-4043314376774351";
const SLOT_ID = "1273102451";

export default function AdSenseServerCard() {
  const adRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!adRef.current || initializedRef.current) return;

    initializedRef.current = true;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error("AdSense initialization failed:", error);
    }
  }, []);

  return (
    <div className="relative overflow-hidden rounded-2xl glass p-6 border border-white/10 flex flex-col min-h-[240px]">
      <div className="absolute -top-12 -right-12 h-32 w-32 rounded-full bg-[#FFBF00]/10 blur-2xl pointer-events-none" />

      <div className="relative flex items-center justify-between gap-3">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#FFBF00]">
          Sponsored
        </span>
        <span className="text-[10px] text-white/40">ADVERTISEMENT</span>
      </div>

      <div className="relative flex-1 flex items-center justify-center mt-4 min-h-[140px]">
        <ins
          ref={adRef}
          className="adsbygoogle"
          style={{ display: "block", width: "100%" }}
          data-ad-client={CLIENT_ID}
          data-ad-slot={SLOT_ID}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>

      <p className="relative mt-4 pt-3 border-t border-white/5 text-xs text-white/50">
        Ads help keep the LostDC Network free. Thanks for your support!
      </p>
    </div>
  );
}
